module.exports = __webpack_public_path__ + "img/lv2.727181bf.png";